// Yoonly NL overrides — only keys that differ from the regular NL translations.
// Missing keys automatically fall back to the standard 'nl' locale, then 'fr'.

const paymentYoonlyNlTranslations = {};

export default paymentYoonlyNlTranslations;
